import httpRequest from '../../utils/httpRequest'
import { setTickerLotSize, setSymbolTickers } from '../tickers/action'

export const SET_PAIRS = 'SET_PAIRS'

export const SET_IS_FETCHING_MARKETS = 'SET_IS_FETCHING_MARKETS'

export const ADD_UNLOGINED_FAVORITES = 'ADD_UNLOGINED_FAVORITES'

export const SET_FAVORITES = 'SET_FAVORITES'

export const setPairs = data => dispatch => dispatch({ type: SET_PAIRS, data })

export const setFavorites = data => dispatch => dispatch({ type: SET_FAVORITES, data })

export const setFetchingMarkets = data => dispatch => {
  dispatch({ type: SET_IS_FETCHING_MARKETS, data })
}

export const getPairs = () => async dispatch => {
  try {
    dispatch(setFetchingMarkets(true))
    let pairs = await httpRequest.getPairs()
    const symbolTickers = await httpRequest.get24HrTicker()
    pairs = pairs.map(p => {
      const ticker = symbolTickers.find(
        st => st.baseAssetName === p.base_asset_symbol && st.quoteAssetName === p.quote_asset_symbol
      ) || { quoteVolume: 0 }

      return {
        volume: Number(ticker.quoteVolume),
        ...p,
      }
    })
    dispatch(setPairs(pairs))
    dispatch(setSymbolTickers(symbolTickers))
    dispatch(setTickerLotSize({ pairs }))
    dispatch(setFetchingMarkets(false))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
